
<template >
  <div class="containerr">
    <span class="Swap" @click="registerPage">{{modalSwitch == 'Login' ? 'Sign Up' : 'Login'}}</span>
    <transition name="slideLeft">
      <form class='login' v-if="modalSwitch == 'Login'">
        <div class="AppName">
          <img src="../assets/GetAGeekLogo.png" width="280" />
        </div>
        <div class='login_fields'>
          <div class='login_fields__user'>
            <input placeholder='Email' type='email' autocomplete="email" v-model="email">
          </div>
          <div class='login_fields__password'>
            <input placeholder='Password' id="LoginpasswordField" type='password' autocomplete="current-password" v-model="password">
          </div>
          <div class='forgot'>
            <a href='#'>Forgotten password?</a>
          </div>
          <div class='login_fields__submit'>
            <button @click="login" id="loginButton" :class="{ 'loginButton': true, 'loading': LoginProgress, 'err': showErr }">
              <span v-if="!LoginProgress">Login</span>
              <span v-if="LoginProgress" class="spinner"></span>
            </button>
          </div>
        </div>
      </form>
    </transition>
    <transition name="slideRight">
      <form v-if="modalSwitch == 'Sign Up'" key="register" class="registerForm">
        <div class="AppName">
          <img src="../assets/GetAGeekLogo.png" width="280" />
        </div>
        <div class='login_fields'>
          <div class='login_fields__user'>
            <input id="registerEmail" placeholder='Email' type='email' autocomplete="email" v-model="email">
          </div>
          <div class='login_fields__password'>
            <input placeholder='Password' id="RegisterpasswordField" type='password' autocomplete="current-password" v-model="password">
          </div>
          <div class='login_fields__submit'>
            <button class="regButton" @click="register">Sign Up</button>
          </div>
        </div>
      </form>
    </transition>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
export default {
  name: "login",
  data: function() {
    return {
      email: "",
      password: "",
      LoginProgress: false,
      loginErr: "",
      showErr: false,
      modalSwitch: ""
    };
  },
  methods: {
    registerPage: function(e) {
      if (this.modalSwitch == "Login") {
        this.modalSwitch = "Sign Up";
        e.preventDefault();
      } else {
        this.modalSwitch = "Login";
        e.preventDefault();
      }
    },
    register: function(e) {
      e.preventDefault();
    },
    login: function(e) {
      this.LoginProgress = !this.LoginProgress;
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(
          user => {
            this.$router.push({ location: "/" });
          },
          err => {
            e.preventDefault();
            this.LoginProgress = !this.LoginProgress;
            this.loginErr = err.message;
            this.showErr = true;
            setTimeout(() => {
              this.showErr = false;
            }, 300);
          }
        );
      e.preventDefault();
    }
  },

  mounted: function() {
    this.$nextTick(function() {
      this.modalSwitch = "Login";
    });
  }
};
</script>
<style scoped>
.slideRight-leave-active,
.slideRight-enter-active {
  transition: 1s;
}
.slideRight-enter {
  transform: translate(300%, 0);
}
.slideRight-leave-to {
  transform: translate(300%, 0);
}

.slideLeft-leave-active,
.slideLeft-enter-active {
  transition: 1s;
}
.slideLeft-enter {
  transform: translate(-300%, 0);
}
.slideLeft-leave-to {
  transform: translate(-300%, 0);
}

.err {
  background-color: #e1645f;
  animation: wiggle 0.3s;
}

@keyframes wiggle {
  0% {
    background-color: #e1645f;
    transform: translate(0px);
  }
  25% {
    background-color: #e1645f;
    transform: translate(10px);
  }
  75% {
    background-color: #e1645f;
    transform: translate(-10px);
  }
  100% {
    background-color: #e1645f;
    transform: translate(0px);
  }
}

.Swap {
  position: fixed;
  right: -130px;
  top: -55px;
  cursor: pointer;
  user-select: none;
  background-color: #e1645f;
  transform: rotateZ(45deg);
  width: 300px;
  height: 150px;
  color: white;
  font-family: "AvenirNext-Heavy";
  font-size: 30px;
  text-align: center;
  padding-top: 100px;
}

.loginButton {
  background-color: #5585ff;
  position: relative;
  right: 4px;
  height: 50px;
  width: 120px;
  background-image: none;
  border: none;
  outline: none;
  color: white;
  font-size: 15px;
  letter-spacing: 1px;
  cursor: pointer;
  border-radius: 30px;
  transition: all ease-out 0.2s;
}

.regButton {
  background-color: #5585ff;
  position: absolute;
  right: 86px;
  height: 50px;
  text-align: center;
  width: 120px;
  margin-top: 30px;
  background-image: none;
  border: none;
  outline: none;
  color: white;
  font-size: 15px;
  letter-spacing: 1px;
  cursor: pointer;
  border-radius: 30px;
  transition: all ease-out 0.2s;
}

.loginButton .active {
  transition-delay: 2s;
  width: 10px;
}
.loading {
  background-color: #6ab776;
  border-radius: 50px;
  width: 50px;
  font-size: 0px;
}

.spinner {
  display: block;
  width: 34px;
  height: 34px;
  position: absolute;
  top: 8px;
  margin: 0 auto;
  left: 0;
  right: 0;
  background: transparent;
  box-sizing: border-box;
  border-top: 4px solid white;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid transparent;
  border-radius: 100%;
  animation-delay: 0.5s;
  animation: spin 1.3s ease-out infinite;
  transition: all ease 0.5s;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}

.AppName {
  padding-right: 5px;
  padding-left: 5px;
}
.containerr {
  padding: 0px;
  overflow: hidden;
  background: linear-gradient(145deg, #2c2e2b, #2c3e50, #2c2e2b);
  background-size: 1200% 1200%;
  -webkit-animation: Gradiant 20s infinite;
  -moz-animation: Gradiant 20s infinite;
  animation: Gradiant 20s infinite;
  display: grid;
  min-height: 100vh;
  min-width: 100vw;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: 0.8fr 2fr 0.8fr;
  grid-template-areas:
    "head head head head"
    "main main main main"
    "footer footer footer footer";
}

@-webkit-keyframes Gradiant {
  0% {
    background-position: 5% 0%;
  }
  50% {
    background-position: 96% 100%;
  }
  100% {
    background-position: 5% 0%;
  }
}
@-moz-keyframes Gradiant {
  0% {
    background-position: 5% 0%;
  }
  50% {
    background-position: 96% 100%;
  }
  100% {
    background-position: 5% 0%;
  }
}
@keyframes Gradiant {
  0% {
    background-position: 5% 0%;
  }
  50% {
    background-position: 96% 100%;
  }
  100% {
    background-position: 5% 0%;
  }
}

.header :nth-child(1) {
  color: #e1645f;
}
.header :nth-child(2) {
  color: #eac547;
}
.header :nth-child(3) {
  color: #6ab776;
}
.header :nth-child(4) {
  color: #8d5fa1;
}
.header :nth-child(5) {
  color: #4b93bb;
}
.header :nth-child(6) {
  color: #4b93bb;
}
.header :nth-child(7) {
  color: #eac547;
}
.header :nth-child(8) {
  color: #6ab776;
}

.header :nth-child(10) {
  color: #8d5fa1;
}
.header :nth-child(11) {
  color: #4b93bb;
}
.header :nth-child(12) {
  color: #e1645f;
}
.header :nth-child(13) {
  color: #eac547;
}

.header :nth-child(15) {
  color: #6ab776;
}
.header :nth-child(16) {
  color: #8d5fa1;
}
.header :nth-child(17) {
  color: #4b93bb;
}
.header :nth-child(18) {
  color: #e1645f;
}
.header :nth-child(19) {
  color: #eac547;
}
.header :nth-child(20) {
  color: #6ab776;
}
.header :nth-child(21) {
  color: #8d5fa1;
}

.login {
  margin: auto;
  grid-area: main;
  background-color: whitesmoke;
  box-shadow: 0.5px 0.5px 8px 0.5px #2c2e2b;
  border-radius: 8px;
  padding-top: 15px;
  min-width: 290px;
  max-width: 390px;
  min-height: 300px;
}

.registerForm {
  margin: auto;
  grid-area: main;
  background-color: whitesmoke;
  box-shadow: 0.5px 0.5px 8px 0.5px #2c2e2b;
  border-radius: 8px;
  padding-top: 15px;
  min-width: 290px;
  max-width: 390px;
  min-height: 300px;
}

.login_title {
  color: #ffffff;
  text-align: center;
  font-family: "Phosphate-Solid";
}
.login_fields {
  position: relative;
}

.login_fields input[type="password"] {
  color: cornflowerblue !important;
}
.login_fields input[type="email"],
.login_fields input[type="password"] {
  color: green;
  width: 80%;
  margin-left: 10%;
  background: #fff;
  outline: none;
  border: solid 1px;
  border-color: #606479;
  border-radius: 80px;
  padding: 10px 10px;
}
.login_fields__user,
.login_fields__password {
  position: relative;
  bottom: -10px;
  padding-bottom: 10px;
}
.login_fields__submit {
  position: relative;
  text-align: center;
  bottom: -15px;
}

.forgot {
  font-size: 13px;
  margin-top: 11px;
  text-align: center;
  color: cornflowerblue;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue